const toggle = document.querySelector('#header .menu_toggle a');
if ( toggle ) {
    toggle.addEventListener('click', function(e) {
        e.preventDefault();
        this.classList.toggle('_active');
        document.body.classList.toggle('_main-menu-active');
        document.getElementById('main_menu_container').classList.toggle('_active');
    });
}

window.addEventListener('scroll', function() {
    if ( document.documentElement.scrollTop > 0 ) {
        document.body.classList.add('_scrolled');
    } else {
        document.body.classList.remove('_scrolled');
    }
});


document.querySelectorAll('[data-scrollto]').forEach(function(link) {
    link.addEventListener('click', function(e) {
        e.preventDefault();
        let top;
        if ( link.getAttribute('href') == '#' ) {
            top = link.closest('.page_section').getBoundingClientRect().bottom + document.documentElement.scrollTop;
        } else if ( link.getAttribute('href').substring(0, 1) == '#' ) {
            top = document.querySelector(link.getAttribute('href')).getBoundingClientRect().top + document.documentElement.scrollTop - document.getElementById('header').offsetHeight;
        } else {
            top = window.innerHeight;
        }
        window.scroll({
            top: top, 
            left: 0, 
            behavior: 'smooth'
        });
    });
});